/**
 * Created by giscafer on 2017/09/21.
 * 基于viewer.js封装
 */

import {
  ContentChild,
  ContentChildren,
  Directive,
  ElementRef,
  Input,
  NgModule,
  Renderer2
} from '@angular/core';
import {CommonModule} from '@angular/common';

declare var Viewer;
export class ViewerContentDirective {

  nativeElement: HTMLElement;
/**
 * @param {?} _el
 */
constructor(private _el: ElementRef) {
    this.nativeElement = this._el.nativeElement;
  }

static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[viewer-content]',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
];
}

function ViewerContentDirective_tsickle_Closure_declarations() {
/** @type {?} */
ViewerContentDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ViewerContentDirective.ctorParameters;
/** @type {?} */
ViewerContentDirective.prototype.nativeElement;
/** @type {?} */
ViewerContentDirective.prototype._el;
}

export class YZTViewerDirective {
  
    originalAttr: string = "name";

   content: ElementRef;
/**
 * @param {?} value
 * @return {?}
 */
set _imgContents(value) {
    this.imgContents = value;
    this.renderContent();
  }

  viewer: any;
  imgContents;
  nativeElement: HTMLElement;
/**
 * @param {?} _elementRef
 * @param {?} _render
 */
constructor(private _elementRef: ElementRef,
private _render: Renderer2) {
    this.nativeElement = this._elementRef.nativeElement;

  }
/**
 * @return {?}
 */
ngOnInit() {
    this.renderContent();
  }
/**
 * 如果img动态增加，则动态渲染
 * @return {?}
 */
renderContent() {
    let /** @type {?} */ nativeEl = this.nativeElement;
    if (this.content) {
      nativeEl = this.content.nativeElement;
    }
    setTimeout(() => {
      let /** @type {?} */ imgs = nativeEl.getElementsByTagName('img');
      if (imgs.length) {
        if (this.viewer) {
          this.viewer.destroy();
        }
        this.viewer = new Viewer(this.nativeElement, {
          url: this.originalAttr,
        });
      }
    },500);
  }
/**
 * @return {?}
 */
ngOnDestroy(): void {
    if (this.viewer) {
      this.viewer.destroy();
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[yzt-viewer]'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: Renderer2, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'originalAttr': [{ type: Input },],
'content': [{ type: ContentChild, args: ['content', ] },],
'_imgContents': [{ type: ContentChildren, args: [ViewerContentDirective, ] },],
};
}

function YZTViewerDirective_tsickle_Closure_declarations() {
/** @type {?} */
YZTViewerDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
YZTViewerDirective.ctorParameters;
/** @type {?} */
YZTViewerDirective.propDecorators;
/** @type {?} */
YZTViewerDirective.prototype.originalAttr;
/** @type {?} */
YZTViewerDirective.prototype.content;
/** @type {?} */
YZTViewerDirective.prototype.viewer;
/** @type {?} */
YZTViewerDirective.prototype.imgContents;
/** @type {?} */
YZTViewerDirective.prototype.nativeElement;
/** @type {?} */
YZTViewerDirective.prototype._elementRef;
/** @type {?} */
YZTViewerDirective.prototype._render;
}

export class YZTViewerDirectiveModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [
    YZTViewerDirective, ViewerContentDirective
  ],
  exports: [YZTViewerDirective, ViewerContentDirective],
  imports: [
    CommonModule
  ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function YZTViewerDirectiveModule_tsickle_Closure_declarations() {
/** @type {?} */
YZTViewerDirectiveModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
YZTViewerDirectiveModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
